import React, { useState } from 'react';

/**
 * Resolve Build Fingerprints: prefer ParsedGame critical_chain, else catalog list fields.
 */
export function resolveFingerprints(replay, parsedReplay) {
  const fromParsed = (parsedReplay?.build_orders || [])
    .map((bo) => bo.critical_chain)
    .filter((fp) => fp && (fp.label || fp.name));
  if (fromParsed.length > 0) {
    return fromParsed;
  }
  return replay?.player_fingerprints || [];
}

async function copyText(text) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }
  const ta = document.createElement('textarea');
  ta.value = text;
  ta.setAttribute('readonly', '');
  ta.style.position = 'absolute';
  ta.style.left = '-9999px';
  document.body.appendChild(ta);
  ta.select();
  document.execCommand('copy');
  document.body.removeChild(ta);
}

/**
 * Per-player Build Fingerprint rows with copy-to-clipboard.
 */
function BuildFingerprintPanel({ fingerprints, showEmptyHint = false }) {
  const [copiedKey, setCopiedKey] = useState(null);

  if (!fingerprints || fingerprints.length === 0) {
    if (!showEmptyHint) return null;
    return (
      <div className="build-fingerprint-panel empty" data-testid="build-fingerprint-panel">
        <span className="build-fingerprint-empty-hint" title="Force re-parse to compute Build Fingerprint">
          Build: —
        </span>
      </div>
    );
  }

  const handleCopy = async (fp, key) => {
    const text = fp.label || '';
    if (!text) return;
    try {
      await copyText(text);
      setCopiedKey(key);
      window.setTimeout(() => {
        setCopiedKey((cur) => (cur === key ? null : cur));
      }, 1500);
    } catch (_) {
      // ignore clipboard errors
    }
  };

  return (
    <div className="build-fingerprint-panel" data-testid="build-fingerprint-panel">
      <div className="build-fingerprint-panel-title">Build Fingerprint</div>
      {fingerprints.map((fp, i) => {
        const key = `${fp.name || 'player'}-${i}`;
        return (
          <div key={key} className="build-fingerprint-row" title={fp.emoji || fp.label}>
            <div className="build-fingerprint-row-text">
              <span className="build-fingerprint-player">{fp.name || 'Player'}</span>
              <code className="build-fingerprint-label">{fp.label || '—'}</code>
            </div>
            <button
              type="button"
              className="build-fingerprint-copy-btn"
              data-testid={`fingerprint-copy-${fp.name || i}`}
              disabled={!fp.label}
              onClick={(e) => {
                e.stopPropagation();
                handleCopy(fp, key);
              }}
              title="Copy Build Fingerprint"
            >
              {copiedKey === key ? 'Copied' : 'Copy'}
            </button>
          </div>
        );
      })}
    </div>
  );
}

export default BuildFingerprintPanel;
